import { Box } from 'features/knowledgeDocumentViewer/components/viewer/shared/types'
import { useMemo } from 'react'

export function useAdjustedBoxes(
  boxes: Box[],
  isMultipage: boolean,
  firstPageWidth: number
) {
  return useMemo(() => {
    if (!isMultipage) {
      return boxes
    }

    return boxes.map((box) => {
      if (box.id.endsWith('-1')) {
        return {
          ...box,
          x: box.x + firstPageWidth,
        }
      }

      return box
    })
  }, [boxes, firstPageWidth, isMultipage])
}
